










/* Created- 23 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "SearchQuery"
	})
export default class SearchQuery extends Vue {
	private query: string = ""; // your data        
	private search() {
		this.$emit("partica-event", { item: this.query, action: eParticaAction.DO_SEARCH } as ParticaEvent);
	}
}
